import debounce from './debounce';
import errorManager from '@/rollbar.js';

let lastScroll = 0;
let initialized = false;
let scrollHandler = null;
let mainContainer = null;

const scrollWatch = () => {
  const titleNav = $('.sticky-title-nav');
  const navigationElt = $('.navigation');
  if (!titleNav.length) return;

  const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  if (currentScroll > lastScroll) {
    mainContainer.addClass('sticky-title-nav-maincont-sticked');
    titleNav.addClass('sticky-title-nav-sticked');
  } else {
    if (window.scrollY <= navigationElt.height()) {
      mainContainer.removeClass('sticky-title-nav-maincont-sticked');
      titleNav.removeClass('sticky-title-nav-sticked');
    }
  }
  lastScroll = currentScroll;
};

const initListener = () => {
  if (initialized) return;
  mainContainer = $('.main--container');
  const titleNav = $('.sticky-title-nav');
  if (!titleNav.length) return;

  scrollHandler = debounce(scrollWatch, 500);
  window.addEventListener('scroll', scrollHandler);
  scrollWatch();
  initialized = true;
};

const destroyListener = () => {
  if (!initialized) return;
  window.removeEventListener('scroll', scrollHandler);
  initialized = false;
  scrollHandler = null;
  lastScroll = 0;
};

const init = () => {
  try {
    initListener();
  } catch (e) {
    errorManager(e);
  }
};

const destroy = () => {
  try {
    destroyListener();
  } catch (e) {
    errorManager(e);
  }
};

window.StickyTitleNav = {
  init: init,
  destroy: destroy,
};
